module.exports = __webpack_public_path__ + "media/assets/services_manager/detail_test1-622e79a7dbc55a964962223929008732110c921f49db2bfb0d546dfddaecd5b9.png";